import { useTranslation } from 'react-i18next';
import { useComponentTKey, i18nNS } from '../i18n';

const useTextOrderByRailList = () => {
  const { t } = useTranslation(i18nNS.rail);
  const { tKey } = useComponentTKey('orderByRailList');
  const newOrderByRailList = [
    {
      label: t(tKey('Price')),
      icon: 'dollar',
      value: 'amountToDisplay',
    },
    {
      label: t(tKey('Depart')),
      icon: 'rail',
      value: 'departureTime',
    },
    {
      label: t(tKey('Arrive')),
      icon: 'rail',
      value: 'arrivalTime',
    },
    {
      label: t(tKey('Duration')),
      icon: 'time',
      value: 'durationTime',
    },
  ];

  return [newOrderByRailList];
};

export default useTextOrderByRailList;
